import React from 'react'
import { Col } from 'react-bootstrap'
import NotificationSettingsForm from './components/notification-settings-form'

const Notifications = () => (
    <Col md={10} mdOffset={1} lg={7}>
        <h2 className="mb-md">Notifications</h2>
        <NotificationSettingsForm />
    </Col>
)

export default Notifications
